import {
  useInfiniteQuery,
  useMutation,
  UseMutationResult,
  useQuery,
} from "@tanstack/react-query";
import { workOuts } from "../products/workOut";
import {
  DeleteParams,
  UserWorkoutsInterface,
  workOutCreateInterface,
  WorkoutDataInterface,
  WorkoutExerciseByIdInterface,
  workOutExerciseCreateInterface,
} from "../types/types";
// created
export function useCreateWorkOut(): UseMutationResult<
  any,
  unknown,
  workOutCreateInterface,
  unknown
> {
  return useMutation({
    mutationFn: (body: workOutCreateInterface) => workOuts.createWorkOut(body),
  });
}
export function useCreateWorkOutExercises(
  id: number
): UseMutationResult<any, unknown, workOutExerciseCreateInterface[], unknown> {
  return useMutation({
    mutationFn: (body: workOutExerciseCreateInterface[]) =>
      workOuts.createWorkOutExercise(body, id),
  });
}

// get
export function useGetWorkOuts(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<WorkoutDataInterface>({
      queryKey: ["getWorkoutData"],
      queryFn: () => workOuts.GetWorkoutData(option),
    });

  return {
    WorkoutData: data,
    WorkoutLoading: isLoading,
    error,
    status,
    isSuccess,
    WorkoutRefetch: refetch,
  };
}
// export function useGetWorkOutsWithScroll(params: any) {
//   return useInfiniteQuery({
//     queryKey: ["getWorkoutData", JSON.stringify(params)],
//     queryFn: async ({ pageParam = 1 }) =>
//       workOuts.GetWorkoutData({ ...params, page: pageParam }),
//     getNextPageParam: (lastPage: WorkoutDataInterface) => {
//       if (
//         lastPage?.meta?.currentPage &&
//         lastPage?.meta?.lastPage &&
//         lastPage.meta.currentPage < lastPage.meta.lastPage
//       ) {
//         return lastPage.meta.currentPage + 1;
//       }
//       return undefined;
//     },
//     initialPageParam: 1,
//   });
// }

export function useGetUserWorkOuts(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<UserWorkoutsInterface>({
      queryKey: ["getUserWorkoutData"],
      queryFn: () => workOuts.GetUserWorkoutData(option),
      enabled: false,
    });

  return {
    WorkoutData: data,
    WorkoutLoading: isLoading,
    error,
    status,
    isSuccess,
    WorkoutRefetch: refetch,
  };
}

// export function useGetWorkOutss(params: any) {
//   return useInfiniteQuery({
//     queryKey: ["getWorkoutData", JSON.stringify(params)],
//     queryFn: ({ pageParam = 1 }) =>
//       workOuts.GetWorkoutData({ ...params, page: pageParam }),
//     getNextPageParam: (lastPage) => {
//       if (
//         lastPage?.meta?.currentPage &&
//         lastPage?.meta?.lastPage &&
//         lastPage.meta.currentPage < lastPage.meta.lastPage
//       ) {
//         return lastPage.meta.currentPage + 1;
//       }
//       return undefined;
//     },
//     initialPageParam: 1,
//   });
// }

export function useGetWorkOutById(id?: number) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<WorkoutExerciseByIdInterface>({
      queryKey: ["getWorkoutExerciseById"],
      queryFn: () => workOuts.GetWorkoutById(id),
      enabled: false,
    });

  return {
    WorkoutData: data,
    WorkoutLoading: isLoading,
    error,
    status,
    isSuccess,
    WorkoutRefetch: refetch,
  };
}

// update
export function useUpdateWorkout(
  id: number
): UseMutationResult<any, unknown, workOutCreateInterface, unknown> {
  return useMutation({
    mutationFn: (body: workOutCreateInterface) =>
      workOuts.UpdateWorkout(body, id),
  });
}

export function useUpdateWorkOutExercises(
  id: number
): UseMutationResult<any, unknown, workOutExerciseCreateInterface[], unknown> {
  return useMutation({
    mutationFn: (body: workOutExerciseCreateInterface[]) =>
      workOuts.UpdateWorkOutExercise(body, id),
  });
}
// delete
export function useDeleteWorkout(): UseMutationResult<
  any,
  unknown,
  DeleteParams,
  unknown
> {
  return useMutation({
    mutationFn: (body: DeleteParams) => workOuts.deleteWorkout(body.id),
  });
}
export function useDeleteWorkoutExercises(): UseMutationResult<
  any,
  unknown,
  DeleteParams,
  unknown
> {
  return useMutation({
    mutationFn: (body: DeleteParams) => workOuts.deleteWorkoutExercise(body.id),
  });
}
